
const SubCategories = {
    Mieszkanie: ['Wybierz', 'Kawalerka', '2-pokoje', '3-pokoje', 'Apartament', 'Loft', 'Penthouse', 'Dwupoziomowe'],
    Dom: ['Wybierz', 'Wolnostojący', 'Szeregowy', 'Bliźniak', 'Rekreacyjny', 'Kamienica', 'Część Domu'],
    Działka : ['Wybierz', 'Budowlana', 'Usługowa', 'Siedliskowa', 'Handlowa', 'Przemysłowa', 'Rekreacyjna', 'Rolna', 'Ogrodnicza'],
    Biuro: ['Wybierz', 'Tradycyjne', 'Co-Working', 'OpenSpace', 'W domu'],
    Lokal: ['Wybierz', 'Użytkowy', 'Handlowy', 'Usługowy', 'Gastronomiczny', 'Showroom'],
    Magazyn: ['Wybierz', 'Hala Magazynowa', 'Centrum Logistyczne', 'Z Chłodnią', 'Wysokiego składowania'],
    Garaż: ['Wybierz', 'Murowany', 'Blaszany', 'Miejsce postojowe', 'Wielostanowiskowy'],
    Years: ['Wybierz', '0-1', '2-3', '3-5', '5-10', 'powyżej 10']
}

export default SubCategories;
